import { useState } from "react";
import { http, formatApiError } from "../lib/api";
import { X, Send } from "lucide-react";
import { confirmClosedClient } from "../components/ClosedClient";

export default function EmailDialog({ kind, doc, defaultTo, onClose, onSent }) {
  const isDevis = kind === "devis";
  const [to, setTo] = useState(defaultTo || doc?.client_email || "");
  const [subject, setSubject] = useState(`${isDevis ? "Devis" : "Facture"} ${doc?.number || ""}`);
  const [message, setMessage] = useState(isDevis
    ? "Bonjour,\n\nVeuillez trouver ci-joint votre devis. Nous restons à votre disposition pour toute question.\n\nCordialement,"
    : "Bonjour,\n\nVeuillez trouver ci-joint votre facture. Merci de procéder au règlement dans les délais indiqués.\n\nCordialement,");
  const [sending, setSending] = useState(false);
  const [err, setErr] = useState("");
  const [info, setInfo] = useState("");

  const send = async () => {
    if (!(await confirmClosedClient(doc?.client_id))) return;
    setSending(true); setErr(""); setInfo("");
    try {
      const path = isDevis ? `/devis/${doc.id}/send-email` : `/factures/${doc.id}/send-email`;
      const { data } = await http.post(path, { to, subject, message });
      if (data.sent) { setInfo("Email envoyé avec succès !"); onSent?.(); setTimeout(onClose, 1200); }
      else setErr(`Non envoyé : ${data.reason || "configurez la clé Resend dans /parametres"}`);
    } catch (e) { setErr(formatApiError(e)); }
    finally { setSending(false); }
  };

  return (
    <div className="fixed inset-0 z-[60] bg-slate-900/40 backdrop-blur-sm grid place-items-center p-4">
      <div className="bg-white rounded-md w-full max-w-lg border border-slate-200 animate-fade-in-up" onClick={(e)=>e.stopPropagation()}>
        <div className="flex items-center justify-between px-5 py-4 border-b border-slate-200">
          <h3 className="font-display text-xl font-bold">Envoyer par email</h3>
          <button onClick={onClose} className="p-1 hover:bg-slate-100 rounded"><X className="h-4 w-4"/></button>
        </div>
        <div className="p-5 space-y-4">
          <L label="Destinataire *"><input data-testid="email-to" type="email" className="input" value={to} onChange={(e)=>setTo(e.target.value)}/></L>
          <L label="Objet"><input className="input" value={subject} onChange={(e)=>setSubject(e.target.value)}/></L>
          <L label="Message"><textarea rows={5} className="input" value={message} onChange={(e)=>setMessage(e.target.value)}/></L>
          {err && <div className="text-sm text-rose-600 bg-rose-50 border border-rose-200 rounded-md px-3 py-2">{err}</div>}
          {info && <div className="text-sm text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-md px-3 py-2">{info}</div>}
        </div>
        <div className="flex items-center justify-end gap-2 px-5 py-4 border-t border-slate-200 bg-slate-50">
          <button onClick={onClose} className="px-4 py-2 text-sm font-semibold border border-slate-300 rounded-md hover:bg-slate-100">Annuler</button>
          <button data-testid="email-send" disabled={sending || !to} onClick={send} className="px-4 py-2 text-sm font-semibold bg-sky-600 hover:bg-sky-700 text-white rounded-md disabled:opacity-70 inline-flex items-center gap-1"><Send className="h-4 w-4"/>{sending?"Envoi…":"Envoyer"}</button>
        </div>
      </div>
      <style>{`.input{width:100%;border:1px solid #cbd5e1;border-radius:6px;padding:.55rem .7rem;font-size:.875rem;outline:none;background:white}.input:focus{border-color:#0284c7;box-shadow:0 0 0 3px #0ea5e933}`}</style>
    </div>
  );
}
function L({label, children}) { return <label className="block"><div className="text-[10px] font-bold uppercase tracking-widest text-slate-500 mb-1">{label}</div>{children}</label>; }
